
import React from "react";
import { CircleLoader } from "react-spinners";
const LoadingSpinner = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircleLoader color="#2f4cdd" loading={true} size={50} />
    </div>
  );
};

export default LoadingSpinner;
